var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-articles"},[_c('h1',[_vm._v(_vm._s(_vm.category.name))]),_vm._v(" "),_vm._l((_vm.category.articles),function({ slug, title },idx){return _c('h2',{key:idx,staticClass:"title"},[_c('nuxt-link',{attrs:{"to":`/support/${slug}/`}},[_vm._v("\n      "+_vm._s(title)+"\n    ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }